import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatButton } from '@angular/material/button';



@Component({
    selector: 'app-toast-message',
    templateUrl: './toast-message.component.html',
    styleUrls: ['./toast-message.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatButton]
})
export class ToastMessageComponent implements OnInit, OnChanges {
  @Input() show;
  @Input() data;
  @Input() message;
  @Input() buttonText;
  @Input() buttonTextUndo;
  @Output() ToastDismiss: EventEmitter<any> = new EventEmitter();
  @Output() AutoDismiss: EventEmitter<any> = new EventEmitter();
  @Output() ToastUndo: EventEmitter<any> = new EventEmitter();
  @Output() ToastAction: EventEmitter<any> = new EventEmitter();
  @Input() undoPresent = false;
  @Input() timerCount = 5000;
  @Input() autoclose = true;
  undoCheck = false;
  constructor() { }

  ngOnInit() {

    this.undoPresent = this.undoPresent !== undefined ? this.undoPresent : false;
    this.show = this.message ? true : false;
  }

  hide(event) {
    event.preventDefault();
    // this.show = false;
    // this.ToastDismiss.emit(event);
  }
  dismiss(event) {
    event.preventDefault();
    this.show = false;
    this.ToastDismiss.emit(event);

  }
  undo(event) {
    this.ToastUndo.emit(event);
  }
  action(event) {
    event.preventDefault();
    this.ToastAction.emit(event);
  }

  ngOnChanges() {
    this.show = this.message ? true : false;
    if (this.show) {
      if (this.autoclose) {
        let startTimer: any;
        // clearTimeout(startTimer);
        startTimer =  setTimeout(() => {
          if (this.show) {
            this.show = false;
            this.AutoDismiss.emit(event);
          }
        }, this.timerCount);
      }
    }
  }

}
